export const BASE_URL =
  process.env.REACT_APP_BASE_URL ||
  window?.BASE_URL ||
  "https://ldssetupdev.ilsp.gr/registry";
export const KEYCLOAK_CONFIG =
  process.env.REACT_APP_KEYCLOAK_CONFIG || window?.KEYCLOAK_CONFIG
    ? JSON.parse(JSON.stringify(window.KEYCLOAK_CONFIG))
    : {};
export const BASENAME =
  process.env.REACT_APP_BASENAME || window?.BASENAME || "/registryui";
export const PARTICIPANT_FORM_SUBMITION =
  BASE_URL + "/api/registry/participants/"; //POST and GET
export const PARTICIPANT_FORM_SCHEMA =
  BASE_URL + "/api/registry/participant/schema/"; //GET
export const PARTICIPANT_FORM_CONNECTOR_SCHEMA =
  BASE_URL + "/api/registry/connector/schema/"; //GET
export const PARTICIPANT_APPROVAL_API =
  BASE_URL + "/api/registry/participant-application/"; //PUT
export const PARTICIPANT_REQUEST_STATUS_CHANGE_API =
  BASE_URL + "/api/registry/request_status_change/"; //PUT
export const PARTICIPANT_EVALUATE_STATUS_CHANGE_API =
  BASE_URL + "/api/registry/evaluate_status_change/"; //PUT
export const PARTICIPANT_SUSPEND_API = BASE_URL + "/api/registry/suspend/"; //PUT
export const PARTICIPANT_EU_TAG_UPDATE = BASE_URL +"/api/registry/eu-tag/"; //PUT
export const PARTICIPANT_LLMS4EU_UPDATE = BASE_URL +"/api/registry/llms4eu_partner/"; //PUT
export const PARTICIPANT_UNSUSPEND_API = BASE_URL + "/api/registry/unsuspend/"; //PUT
export const PARTICIPANT_REOPEN_API = BASE_URL + "/api/registry/reopen/"; // /api/registry/reopen/ allowed for admin for withdrawn/rejected status
export const PARTICIPANT_WITHDRAW_API = BASE_URL + "/api/registry/withdraw/"; //PUT
export const PARTICIPANT_DISPLAY = (id) =>
  `${BASE_URL}/api/registry/participants/${id}/`;
export const PARTICIPANT_CONNECTOR = (id) =>
  `${BASE_URL}/api/registry/connectors/${id}/`;
export const PARTICIPANT_CONNECTORS = BASE_URL + "/api/registry/connectors/"; // GET/POST
export const PARTICIPANT_EXPORT_API = BASE_URL + "/api/registry/export/";
export const CONNECTOR_EXPORT_API = BASE_URL + "/api/registry//export_connectors/";
export const PARTICIPANT_REQUEST_DELETION =
  BASE_URL + "/api/registry/connector-request-deletion/";
export const PARTICIPANT_EVALUATE_DELETION =
  BASE_URL + "/api/registry/connector-evaluate-deletion/";
export const PARTICIPANT_DOCUMENTS = BASE_URL + "/api/registry/documents/"; // GET/POST
export const PARTICIPANT_DOCUMENTS_METADATA = (id) =>
  `${BASE_URL}/api/registry/documents/${id}/`;
//export const PARTICIPANT_RETRIEVE_ACTUAL_DOCUMENT = BASE_URL + "/media/";
const url = new URL(BASE_URL);
const url_base = `${url.protocol}//${url.hostname}`;
export const PARTICIPANT_RETRIEVE_ACTUAL_DOCUMENT =
  url_base + "/regstorage/media/";

export const FC_BASE_URL = url_base + "/fc";

// 1. Get the connector list (uses the existing connectors endpoint)
export const PROXY_GET_PARTICIPANTS = PARTICIPANT_CONNECTORS;
// 2. Send a broadcast (POST to /fc/messages/broadcast)
export const PROXY_BROADCAST_MESSAGE = FC_BASE_URL + "/messages/broadcast";
export const PROXY_BROADCAST_POLL_MESSAGE = FC_BASE_URL + "/messages/{id}";
// 3. List sent broadcasts (GET from /fc/messages)
export const PROXY_GET_OUTBOX_MESSAGES = FC_BASE_URL + "/messages";

// 4. Get a single sent broadcast detail (GET from /fc/messages/{id})
export const PROXY_GET_SPECIFIC_MESSAGE = (id) => `${FC_BASE_URL}/messages/${id}`;


/*/api/registry/participant/schema/en/' 	Participant Schema	public   GET
/api/registry/connector/schema/en/' 	Connector Schema	public GET
/api/registry/participants/		List/Create Participant(s)	admin / participant (is owner) GET/POST
/api/registry/participants/[id]/		Get/Update/Delete Participant		admin / participant (is owner) GET/PUT/DELETE
/api/registry/connectors/		List/Create Connector(s)		admin / participant (is owner of connector's participant object) GET/POST
/api/registry/connectors/[id]		Get/Update/Delete Connector		admin / participant (is owner of connector's participant object) GET/PUT/DELETE
*/
